import { combineReducers } from '@reduxjs/toolkit';

import menuReducer from './slices/menu';
import snackbarReducer from './slices/snackbar';
import createEventReducer from './slices/createEvent';
import eventDashboardMenuListSlice from './slices/eventDashboardMenuListSlice';
import eventCreationMessagesReducer from './slices/eventCreationMessages';
import authDialogSlice from './slices/authDialog';
// import authSlice from './slices/auth/authService'
import userGeoLocationSlice from './slices/userGeolocation';
import teamSlice from './slices/event/team/team';
import invitationSlice from './slices/event/invitation';
import registrationSlice from './slices/event/registration';
import firebaseAuthSlice from './slices/auth/firebaseAuthService';
import authSlice from './slices/auth/authSlice';
import bankSlice from './slices/bank/bank';
import eventSetupSlice from './slices/event/eventSetup';
import eventSlice from './slices/event/event';
import gstSlice from './slices/gst-rates/gst';
import ticketSlice from './slices/ticket/ticket';
import citiesSlice from './slices/cities';
import ticketBuyingSlice from './slices/ticket/ticketBuying'
import adminSettingsSlice from "./slices/admin-settings/adminSettings"
import contactUsSlice from './slices/contact-us/contactUs'
import userSlice from './slices/user/user'
import attendeeRegistrationSlice from './slices/event/registration/registration'
import eventSettingSlice from './slices/event/settings/eventSettings';
import eventBookingSlice from './slices/user/event-bookings/eventBookings';

const rootReducer = combineReducers({
    menu: menuReducer,
    snackbar: snackbarReducer,
    createEvent: createEventReducer,
    eventDashboardMenListSlice: eventDashboardMenuListSlice,
    eventCreationMessages: eventCreationMessagesReducer,
    authDialog: authDialogSlice,
    // auth: authSlice,
    userGeolocation: userGeoLocationSlice,
    team: teamSlice,
    invitation: invitationSlice,
    registration: registrationSlice,
    firebaseAuth: firebaseAuthSlice,
    auth: authSlice,
    bank: bankSlice,
    eventSetup: eventSetupSlice,
    event: eventSlice,
    gst: gstSlice,
    ticket: ticketSlice,
    cities: citiesSlice,
    ticketBuying: ticketBuyingSlice,
    adminSettings: adminSettingsSlice,
    contactUs: contactUsSlice,
    user: userSlice,
    attendeeRegistration: attendeeRegistrationSlice,
    eventSettings: eventSettingSlice,
    eventBookings: eventBookingSlice,
});

export default rootReducer;